var React = require('react');

function Emergency (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M16 15v-2h-3v-3h-2v3H8v2h3v3h2v-3h3zm4-9c.58 0 1.05.2 1.42.59.38.41.58.86.58 1.41v12c0 .55-.2 1-.58 1.41-.37.39-.84.59-1.42.59H4c-.58 0-1.05-.2-1.42-.59C2.2 21 2 20.55 2 20V8c0-.55.2-1 .58-1.41C2.95 6.2 3.42 6 4 6h4V4c0-.58.2-1.05.58-1.42C8.95 2.2 9.42 2 10 2h4c.58 0 1.05.2 1.42.58.38.37.58.84.58 1.42v2h4zM4 8v12h16V8H4zm10-2V4h-4v2h4z"}));
}

Emergency.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Emergency;

Emergency.default = Emergency;
